
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/downloads",
      function () {
        return require("private-next-pages/downloads/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/downloads"])
      });
    }
  